import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

// Un periodo nuevo arranca el dia 1 del mes siguiente al de hoy: el periodo que
// se esta por registrar todavia no empezo.
const FECHA_INICIO_POR_DEFECTO = () =>
    moment().add(1, 'month').startOf('month').format('yyyy-MM-DD');

const initialState = {
    defaultEntity: {
        id: 0,
        // El periodo no tiene filial: es comun a todas las sedes.
        idTipoTerapia: 0,
        tipoTerapia: "",
        idTipoTerapiaPadre: 0,
        idCategoria: 67,
        categoria: "Academico",
        // El codigo lo arma el API al guardar, asi que el campo Codigo no es
        // obligatorio mientras esta marcado.
        generarCodigo: true,
        codigo: "",
        idEstadoApertura: 87,
        estadoApertura: "Abierto",
        // Por defecto el periodo es mensual (catalogo 300).
        idPeriodicidad: 303,
        periodicidad: "Mensual",
        diasLaborables: 0,
        fechaInicio: FECHA_INICIO_POR_DEFECTO(),
        fechaFin: moment().format('yyyy-MM-DD'),
        idEstado: 2,
        estado: "Activo",
        observaciones: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
      id: 0,
      // El periodo no tiene filial: es comun a todas las sedes.
      idTipoTerapia: 0,
      tipoTerapia: "",
      idTipoTerapiaPadre: 0,
      idCategoria: 0,
      categoria: "",
      // El codigo lo arma el API al guardar, asi que el campo Codigo no es
      // obligatorio mientras esta marcado.
      generarCodigo: true,
      codigo: "",
      idEstadoApertura: 0,
      estadoApertura: "",
      // Por defecto el periodo es mensual (catalogo 300).
      idPeriodicidad: 303,
      periodicidad: "Mensual",
      diasLaborables: 0,
      fechaInicio: FECHA_INICIO_POR_DEFECTO(),
      fechaFin: moment().format('yyyy-MM-DD'),
      idEstado: 2,
      estado: "Activo",
      observaciones: "",
      fechaRegistro: null,
      usuarioRegistro: null,
      fechaModificacion: null,
      usuarioModificacion: null,
    },
    listTiposTerapias: [{id: 0, descripcion: ""}],
    listCategorias: [{id: 0, descripcion: ""}],
    listEstadosApertura: [{id: 0, descripcion: ""}],
    listEstados: [{id: 0, descripcion: ""}],
    listPeriodicidades: [{id: 0, descripcion: ""}],
    // Detalle del periodo: periodos Academicos referenciados.
    listPeriodoDetalle: [{id: 0, idPeriodo: 0, idPeriodoDetalleRef: 0, codigoPeriodoDetalle: ""}],
    validationActive: {
      idTipoTerapia: false,
      codigo: false,
      fechaInicio: false,
    },
    validationMessage: [],
  }
  
  export const periodSlice = createSlice({
    name: "period",
    initialState,
    reducers: {
      setEntity: (state, action) => {
        state.entity = action.payload;
      },
      setData: (state, action) => {
        var { name, value } = action.payload;
  
        if (name.startsWith("id")) value = parseInt(value)
        
        state.entity[name] = value
        state.validationActive[name] = true
      },
      setValidationMessage: (state, action) => {
        state.validationMessage = action.payload;
      },
      activeValidations: (state, action) => {
        Object.keys(state.validationActive).forEach(function (key) {
          state.validationActive[key] = true;
        })
      },
      setListTiposTerapias: (state, action) => {
        state.listTiposTerapias = action.payload;
      },
      setListCategorias: (state, action) => {
        state.listCategorias = action.payload;
      },
      setListEstadosApertura: (state, action) => {
        state.listEstadosApertura = action.payload;
      },
      setListEstados: (state, action) => {
        state.listEstados = action.payload;
      },
      setListPeriodicidades: (state, action) => {
        state.listPeriodicidades = action.payload;
      },
      setListPeriodoDetalle: (state, action) => {
        state.listPeriodoDetalle = action.payload;
      },
      setDiasLaborables: (state, action) => {
        state.entity.diasLaborables = action.payload;
      },
    },
  });
  
  export const { setEntity, setData, setValidationMessage, activeValidations
    , setListTiposTerapias, setListCategorias, setListEstadosApertura, setListEstados
    , setListPeriodicidades, setDiasLaborables, setListPeriodoDetalle } = periodSlice.actions;
  export default periodSlice.reducer;
  